import { Box, styled } from '@mui/material';

import { ganttFlightBoxHeight, ganttFlightBoxMarginTop, ganttFlightRowMargin } from '../gantt.constants';

export const collapsedGanttGroupHeight = 50;
export const groupNameWidth = 65;

export const getGroupHeight = (vh: number, nbRows: number) => {
    const height = (ganttFlightBoxHeight + ganttFlightBoxMarginTop) * (nbRows || 0) + ganttFlightRowMargin; //+ ganttFlightRowMargin;
    return Math.min((33 * vh) / 100, Math.max(50, height));
};

export const GanttGroup = styled(Box)<{ groupheight: number }>`
    position: relative;
    z-index: 1;
    width: calc(100% + 10px);
    min-height: ${collapsedGanttGroupHeight}px;
    height: ${({ groupheight }) => groupheight}px;
    box-sizing: content-box; // allow cursor hover to pass through to OverCapacity alerts
`;
export const GanttGroupName = styled(Box)`
    position: sticky;
    top: 20px;
    bottom: 0;
`;
